import React, { Component } from 'react';
import Header from '../components/Header/header';
import { Link } from 'react-router-dom';

class Failure extends Component {
   constructor(props) {
      super(props);
      this.state = {
         errorCode: '',
      };
   }

   componentDidMount() {
      const vars = {};
      window.location.href.replace(
         /[?&]+([^=&]+)=([^&]*)/gi,
         function (m, key, value) {
            vars[key] = value;
         }
      );
      if (vars.error) {
         let error = {
            3001: 'La tarjeta fue declinada.',
            3002: 'La tarjeta ha expirado.',
            3003: 'La tarjeta no tiene fondos suficientes.',
            3004: 'La tarjeta ha sido identificada como una tarjeta robada.',
            3005: 'La tarjeta ha sido rechazada por el sistema antifraudes.',
            3006: 'La operación no esta permitida para este cliente o esta transacción.',
            3007: 'Deprecado. La tarjeta fue declinada.',
            3008: 'La tarjeta no es soportada en transacciones en línea.',
            3009: 'La tarjeta fue reportada como perdida.',
            3010: 'El banco ha restringido la tarjeta.',
            3011: 'El banco ha solicitado que la tarjeta sea retenida. Contacte al banco.',
            3012: 'Se requiere solicitar al banco autorización para realizar este pago.',
         };

         this.setState({ errorCode: error[vars.error] });
      }
   }
   render() {
      return (
         <div className="flex column">
            <Header inicio={true}></Header>
            <div className="justify-center">
               <div className="container">
                  <div className="column politicas">
                     <div className="white-space-48"></div>
                     <div className="checkpay justify-center">
                        <div className="container column">
                           <div className="wow fadeIn" data-wow-delay="1s">
                              <svg
                                 version="1.1"
                                 xmlns="http://www.w3.org/2000/svg"
                                 viewBox="0 0 130.2 130.2"
                              >
                                 <circle
                                    className="path circle"
                                    fill="none"
                                    stroke="#000000"
                                    stroke-width="6"
                                    stroke-miterlimit="10"
                                    cx="65.1"
                                    cy="65.1"
                                    r="62.1"
                                 />
                                 <line
                                    className="path line"
                                    fill="none"
                                    stroke="#000000"
                                    stroke-width="6"
                                    stroke-linecap="round"
                                    stroke-miterlimit="10"
                                    x1="34.4"
                                    y1="37.9"
                                    x2="95.8"
                                    y2="92.3"
                                 />
                                 <line
                                    className="path line"
                                    fill="none"
                                    stroke="#000000"
                                    stroke-width="6"
                                    stroke-linecap="round"
                                    stroke-miterlimit="10"
                                    x1="95.8"
                                    y1="38"
                                    x2="34.4"
                                    y2="92.2"
                                 />
                              </svg>
                           </div>

                           <div className="white-space-32" />
                           <h2
                              className="color-black text-center wow fadeIn"
                              data-wow-delay="1.2s"
                           >
                              ¡LO SENTIMOS, TU PAGO HA SIDO RECHAZADO!
                           </h2>
                           <div className="white-space-32" />
                           <h2
                              className="color-black text-center uppercase wow fadeIn"
                              data-wow-delay="1.2s"
                           >
                              {this.state.errorCode
                                 ? this.state.errorCode
                                 : null}
                           </h2>
                           <div className="white-space-32" />
                           <div
                              className="btn-container-check-status justify-center wow fadeIn"
                              data-wow-delay="1.4s"
                           >
                              <Link className="btn btn-red color-white" to="/">
                                 INICIO
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="white-space-48"></div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default Failure;



// WEBPACK FOOTER //
// ./src/pages/failure.js